import { Card, Flex, Tabs, Typography } from "antd";

const { Text } = Typography;

const data = [
  { name: "Bangladesh", learners: "78,432" },
  { name: "India", learners: "54,321" },
  { name: "United States", learners: "89,765" },
  { name: "England", learners: "32,198" },
  { name: "Canada", learners: "47,650" },
  { name: "Russia", learners: "91,234" },
];

export default function TopPlacesTable() {
  return (
    <Card
      className="shadow-sm bordered-card custom-card h-full"
      title={
        <span className="text-theme-slate-800 text-lg font-medium">
          Top Places
        </span>
      }
    >
      <div className="border border-theme-slate-100">
        <Flex align="center" justify="space-between" className="px-3 pb-3 pt-2">
          <Tabs
            defaultActiveKey="country"
            items={[
              { label: "Country", key: "country" },
              { label: "City", key: "city" },
            ]}
            size="small"
            className="country-tabs"
          />
          <span className="text-theme-slate-600 text-sm font-normal">
            Learners
          </span>
        </Flex>
        <div className="space-y-0 border-t border-theme-slate-100">
          {data.map((item, index) => (
            <div
              key={index}
              className="flex justify-between py-4 border-b border-theme-slate-100 last:border-0 hover:bg-slate-50 transition-colors px-3"
            >
              <Text className="text-theme-slate-700 text-sm font-medium">
                {item.name}
              </Text>
              <Text className="text-theme-slate-800 text-sm font-bold">
                {item.learners}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
